enum ActionTypes {
	request = 'Country.request',
	receive = 'Country.receive',
}

export default ActionTypes;
